import Calendar from '@assets/icons/calendar.svg'
import { Icon } from './Icon'

export const CalendarIcon = Icon(Calendar)
